import React from 'react'

interface SidebarBoxProps extends React.HTMLAttributes<HTMLDivElement> { }

export const SidebarBox = ({ children, ...props }: SidebarBoxProps) => {
    return (
        <div
            className={`bg-shade-0 flex flex-col h-full max-h-full overflow-auto w-96 shrink-0 border-l border-shade-200 ${props?.className}`}
        >
            {children}
        </div>
    )
}
